(() => {
	function EmailSettingsController(
		$scope,
		$rootScope,
		$location,
		$routeParams,
		messageService,
		validationService,
		emailSettingsDataService,
		emailService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.isGmailSpinnningWheelActive = false;
			$scope.isGmailReplySpinningWheelActive = false;
			$scope.isSMTPSpinnningWheelActive = false;
			$scope.isAddSignatureSpinnningWheelActive = false;
			$scope.isSNServerSettingsSpinnningWheelActive = false;
			$scope.isSMTPSettingsSpinnningWheelActive = false;
			$scope.isImageLoadedSuccess = false;

			const code = $routeParams.code;
			$scope.code = code;

			if (code) {
				if ($rootScope.activateCode !== code) {
					$rootScope.activateCode = code;
					saveGmailConnection(code);

					messageService.showToaster('i_0', 'general');
				}
			} else {
				$rootScope.activateCode = '';
			}

			getSettings();
			showSpinnerImageUploading();
		});

		window.changeImg = false;

		$scope.saveEmailSignature = () => {
			$scope.isAddSignatureSpinnningWheelActive = true;
			let signature = $scope.setting.signature;

			signature = $rootScope.addMaiStyling(signature);

			emailSettingsDataService
				.saveEmailSignature(signature)
				.finally(() => ($scope.isAddSignatureSpinnningWheelActive = false))
				.subscribe(() => successSaveSignature(), () => errorSaveSignature());
		};

		$scope.uploadSignature = (formData, insertCallback) => {
			const companyImageError = () => {
				toastr.error(
					'Please make sure you upload a valid .JPG or .PNG file into the email signature.',
					"Something's not right here!"
				);
			};
			const companyImageSizeError = () => {
				toastr.error("The file you're attaching is bigger than the 2 Mb.");
			};
			const serverError = () => {
				toastr.error('Failed request to server');
			};

			function saveNewImgOnServer(formData) {
				emailSettingsDataService.setOnLoadImageSuccess(true);
				emailSettingsDataService.saveImage(formData).subscribe(
					result => {
						if (result.errorMessage === 'Unsupported Image Type!') {
							companyImageError();
							return;
						}
						getSettings();
						emailSettingsDataService.setOnLoadImageSuccess(false);
						messageService.showToaster('s_4', 'emailSettings');
					},
					() => serverError()
				);
			}

			const insertImg = function(imgSrc) {
				const insertImgUrl = `${imgSrc}?${new Date().getTime()}`;
				const htmlText = `<img src='${insertImgUrl}'/>`;

				insertCallback({
					html: htmlText,
					length: 1
				});
			};

			function getSettings() {
				emailSettingsDataService.getEmailSettings().subscribe(
					result => {
						insertImg(result.imageUrl);
					},
					() => serverError()
				);
			}

			return saveNewImgOnServer(formData);
		};

		function showSpinnerImageUploading() {
			emailSettingsDataService.getOnLoadImageSuccess.subscribe(
				value => ($scope.isImageLoadedSuccess = value)
			);
		}

		function successSaveSignature() {
			messageService.showToaster('s_2', 'emailTemplate');
		}

		function errorSaveSignature() {
			messageService.showToaster('e_0', 'general');
		}

		$scope.saveSnServerSettings = () => {
			$scope.isSNServerSettingsSpinnningWheelActive = true;

			const settings = $scope.setting.defaultSettings;
			$scope.defaultSettings = JSON.parse(
				JSON.stringify($scope.setting.defaultSettings)
			);
			const { replyTo, from } = settings;

			if (validationService.isStringEmpty(replyTo)) {
				$scope.isSNServerSettingsSpinnningWheelActive = false;
				return messageService.showToaster('e_0', 'emailSettings');
			}

			if (validationService.isStringEmpty(from)) {
				$scope.isSNServerSettingsSpinnningWheelActive = false;
				return messageService.showToaster('e_1', 'emailSettings');
			}

			emailSettingsDataService
				.saveSnServerSettings(settings)
				.finally(() => ($scope.isSNServerSettingsSpinnningWheelActive = false))
				.subscribe(
					() => successSaveSnServerSettings(),
					() => errorSaveSaveSnServerSettings()
				);
		};

		function successSaveSnServerSettings() {
			messageService.showToaster('s_2', 'emailTemplate');
			$('#snServerSettingsModal').modal('hide');
		}

		function errorSaveSaveSnServerSettings() {
			messageService.showToaster('e_0', 'general');
		}

		$scope.onConnectGmail = () => {
			$scope.connectGmail();
		};

		function getEmailData() {
			return emailSettingsDataService.getGmailReplyData();
		}

		function successGetEmailData(data) {
			if (data) {
				if (data.replySettingsMetadata) {
					$scope.replyAccountCredentialId =
						data.replySettingsMetadata.replyAccountCredentialId;
				}
				$scope.emailReplyData = data;
				$('#emailReplyModal').modal('show');
			}
		}

		$scope.openGmailPreferences = () => {
			$rootScope.lockSettingButtons = true;
			getEmailData()
				.finally(() => {
					$rootScope.lockSettingButtons = false;
				})
				.subscribe(data => {
					successGetEmailData(data.data);
				});
		};

		$scope.onSaveSettings = event => {
			$scope.isGmailReplySpinningWheelActive = true;
			let replyAccountCredentialId;
			let receiveReplies;
			if (!event.data.replySettingsMetadata) {
				receiveReplies = false;
				replyAccountCredentialId = null;
			} else {
				replyAccountCredentialId =
					event.data.replySettingsMetadata.replyAccountCredentialId;
				receiveReplies = event.data.replySettingsMetadata.enabled;
			}

			saveGmailSettings(
				replyAccountCredentialId,
				receiveReplies,
				event.data.senderName,
				event.data.senderEmail
			);
			$location.url($location.path());
		};
		$scope.connectGmail = () => {
			$scope.isGmailSpinnningWheelActive = true;

			emailSettingsDataService
				.connectGmailServer()
				.finally(() => ($scope.isGmailSpinnningWheelActive = false))
				.subscribe(
					data => successConnectGmail(data.url),
					error => errorConnectGmail()
				);
		};

		$scope.onModalClose = () => {
			$location.url($location.path());
		};

		function successConnectGmail(url) {
			window.location.assign(url);
		}

		function errorConnectGmail() {
			messageService.showToaster('e_0', 'general');
		}

		$scope.disconnectGmail = () => {
			emailSettingsDataService
				.disconnectGmailServer()
				.finally(() => ($scope.isGmailSpinnningWheelActive = false))
				.subscribe(
					() => successDisconnectGmail(),
					() => errorDisconnectGmail()
				);
		};

		function successDisconnectGmail() {
			changeServerType('DEFAULT');
			messageService.showToaster('s_0', 'emailSettings');
		}

		function errorDisconnectGmail() {
			messageService.showToaster('e_0', 'general');
		}

		function saveGmailConnection(
			code,
			accountCredentialId,
			receiveReplies,
			senderName,
			senderEmail
		) {
			emailSettingsDataService
				.saveGmailConnection(
					code,
					accountCredentialId,
					receiveReplies,
					senderName,
					senderEmail
				)
				.switchMap(() => getEmailData())
				.finally(() => {
					$rootScope.lockSettingButtons = false;
					$scope.isGmailReplySpinningWheelActive = false;
				})
				.subscribe(
					data => {
						changeServerType('GMAIL');
						successGetEmailData(data.data);
					},
					() => errorSaveGmailConnection()
				);
		}

		function saveGmailSettings(
			accountCredentialId,
			receiveReplies,
			senderName,
			senderEmail
		) {
			emailSettingsDataService
				.saveGmailReplySettingData(
					accountCredentialId,
					receiveReplies,
					senderName,
					senderEmail
				)
				.finally(() => {
					$location.url($location.path());
					$rootScope.lockSettingButtons = false;
					$scope.isGmailReplySpinningWheelActive = false;
				})
				.subscribe(
					() => successSaveGmailConnection(),
					error => errorSaveGmailConnection(error)
				);
		}

		function successSaveGmailConnection() {
			changeServerType('GMAIL');
			messageService.showToaster('s_2', 'emailSettings', 'Gmail');
			$('#emailReplyModal').modal('hide');
		}

		function errorSaveGmailConnection(error) {
			$location.url($location.path());
			if (!!error.error.errorMessage || !!error.error.errorTitle) {
				let { errorMessage, errorTitle } = error.error;
				if (errorTitle === '') {
					errorTitle = 'Whoops, something has gone wrong!';
				}
				messageService.showErrorFromBackend(errorTitle, errorMessage);
			} else {
				messageService.showToaster('e_5', 'emailSettings');
			}
		}

		$scope.openSMTPServerSettingsModal = function() {
			$rootScope.lockSettingButtons = true;
			emailSettingsDataService
				.getSmtpData()
				.finally(() => ($rootScope.lockSettingButtons = false))
				.subscribe(data => {
					$scope.smtpData = JSON.parse(JSON.stringify(data));
					$('#smptServerSettingsModal').modal('show');
				});
		};

		$scope.onSmtpSave = () => {
			changeServerType('SMTP_SERVER');
			$('#smptServerSettingsModal').modal('hide');
		};

		$scope.disconnectSMTP = () => {
			$scope.lockSettingButtons = true;

			emailSettingsDataService
				.disconnectSMTPServer()
				.finally(() => ($scope.lockSettingButtons = false))
				.subscribe(() => successDisconnectSMTP(), () => errorDisconnectSMTP());
		};

		function successDisconnectSMTP() {
			changeServerType('DEFAULT');
			messageService.showToaster('s_1', 'emailSettings');
		}

		function errorDisconnectSMTP() {
			messageService.showToaster('e_0', 'general');
		}

		function changeServerType(serverType) {
			$scope.isDefaultServer = false;
			$scope.isGmailConnected = false;
			$scope.isSMTPConnected = false;

			switch (serverType) {
				case 'SMTP_SERVER':
					$scope.isSMTPConnected = true;
					break;
				case 'GMAIL':
					$scope.isGmailConnected = true;
					break;
				default:
					/* if it's DEFAULT server type */
					$scope.isDefaultServer = true;
			}
		}

		$scope.sentNewNotification = () => {
			emailSettingsDataService
				.activateEmailNotification($scope.setting.sendNotification)
				.subscribe(
					data => successSentNewNotification(data),
					err => messageService.showDefaultErrorMessage(err)
				);
		};

		function successSentNewNotification(data) {
			if (data) {
				if (data.errorMessage) {
					toastr.error(data.errorMessage, 'Error');
				} else {
					messageService.showToaster('s_5', 'emailTemplate');
				}
			} else {
				toastr.error('Wrong link');
			}
		}

		$scope.openSnServerSettingsModal = function() {
			$scope.modal_title = 'Studio Ninja server settings (default)';

			if (
				JSON.stringify($scope.defaultSettings) !==
				JSON.stringify($scope.setting.defaultSettings)
			) {
				$scope.setting.defaultSettings = JSON.parse(
					JSON.stringify($scope.defaultSettings)
				);
			}

			$('#snServerSettingsModal').modal('show');
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Email Settings' }
		];

		function getSettings() {
			// $('#emailReplyModal').modal('show');
			emailSettingsDataService
				.getEmailSettings()
				.subscribe(
					data => successGetSettings(data),
					error => messageService.showDefaultErrorMessage(error)
				);
		}

		function successGetSettings(data) {
			if (data) {
				$scope.setting = data;
				$scope.defaultSettings = JSON.parse(
					JSON.stringify($scope.setting.defaultSettings)
				);
				changeServerType($scope.setting.activeServerType);
			} else {
				$scope.setting = {
					sendNotification: true
				};
			}
		}

		$scope.disableDragDrop = function() {
			return true;
		};

		$scope.addSubjectVariable = function($event, id) {
			const el = document.getElementById(id);
			emailService.addSubjectVariable(el, $event);
		};

		$scope.activatePromoSubscription = () => {
			emailSettingsDataService
				.activatePromoSubscription($scope.setting.promoSubscription)
				.subscribe(
					() => {
						messageService.showToaster('s_0', 'general', 'Settings updated');
						getSettings();
					},
					error => messageService.showDefaultErrorMessage(error)
				);
		};
	}

	angular
		.module('main')
		.controller('EmailSettingsController', EmailSettingsController);

	EmailSettingsController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$routeParams',
		'messageService',
		'validationService',
		'emailSettingsDataService',
		'emailService'
	];
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/emailSettingsController.js